var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMobileAlt1SvgrepoCom1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0005 18.3242H13.0005M9.20049 21.3242H14.8005C15.9206 21.3242 16.4807 21.3242 16.9085 21.1062C17.2848 20.9145 17.5908 20.6085 17.7825 20.2322C18.0005 19.8044 18.0005 19.2443 18.0005 18.1242V6.52422C18.0005 5.40412 18.0005 4.84406 17.7825 4.41624C17.5908 4.03991 17.2848 3.73395 16.9085 3.54221C16.4807 3.32422 15.9206 3.32422 14.8005 3.32422H9.20049C8.08039 3.32422 7.52033 3.32422 7.09251 3.54221C6.71618 3.73395 6.41022 4.03991 6.21848 4.41624C6.00049 4.84406 6.00049 5.40411 6.00049 6.52422V18.1242C6.00049 19.2443 6.00049 19.8044 6.21848 20.2322C6.41022 20.6085 6.71618 20.9145 7.09251 21.1062C7.52033 21.3242 8.08038 21.3242 9.20049 21.3242Z",
    stroke: "#5D2EDE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileAlt1SvgrepoCom1);
export default __webpack_public_path__ + "static/media/mobile-alt-1-svgrepo-com 1.c543a2f8c5f9e40028a8920d4d42f7d7.svg";
export { ForwardRef as ReactComponent };